import React, { useEffect, useState } from "react"
import { Link } from "react-router"
import { useTranslation } from "react-i18next"
import { Dropdown } from "react-bootstrap"

import DeleteModal from "pages/parts/DeleteModal"
import { DELETE, GET, httpOk } from "helpers/api"
import { formatDate, formatMoney } from "helpers/helpers"

/**
 * Основания начисления: три по факту (бывшие типы КПИ 7 / 6 / 8),
 * два по плану (смены графика работы) и одно по следу в системе (дни по продажам)
 */
export function rateBasisName(t, basis) {
	if (basis === "shift_hours") return t("rate_shift_hours")
	if (basis === "attendance_days") return t("rate_attendance_days")
	if (basis === "schedule_days") return t("rate_schedule_days")
	if (basis === "schedule_hours") return t("rate_schedule_hours")
	if (basis === "sales_days") return t("rate_sales_days")
	return t("rate_attendance_hours")
}

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteId, setDeleteId] = useState(0)

	async function getData() {
		const response = await GET("/employee-time-rates", {}, { loader: true })
		if (httpOk(response)) setData(response.data.data || [])
	}

	async function deleteItem() {
		const response = await DELETE(`/employee-time-rates/${deleteId}`, {}, { loader: true })
		if (httpOk(response)) {
			setModalDelete(false)
			setDeleteId(0)
			getData()
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t("time_rates")} [{data.length}]
				</h4>
				<div className="d-flex">
					<Link className="btn-rounded btn btn-primary" to="/employee-time-rates/create">
						{t("create")}
					</Link>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: "33px" }} className="text-center">#</th>
									<th style={{ width: "25%" }}>{t("title")}</th>
									<th style={{ width: "15%" }}>{t("rate_basis")}</th>
									<th style={{ width: "10%" }} className="text-end">{t("rate_amount")}</th>
									<th style={{ width: "30%" }}>{t("program_participants")}</th>
									<th style={{ minWidth: "170px" }} className="text-center">{t("period")}</th>
									<th style={{ minWidth: "100px" }} className="text-center">{t("status")}</th>
									<th style={{ minWidth: "33px" }}></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={item.id || index}>
										<td className="text-center">{index + 1}</td>
										<td title={item.created_by_name ? `${t('created_by')}: ${item.created_by_name}` : ''}>
											{item.name}
										</td>
										<td>{rateBasisName(t, item.rate_basis)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.rate)}</td>
										<td className="td-ellipsis"
											title={item.participant_mode === "by_user" ? item.users_names : item.positions_names}>
											{item.participant_mode === "by_user"
												? `${t("employees")}: ${item.users_names || "—"}`
												: `${t("positions")}: ${item.positions_names || "—"}`}
										</td>
										<td className="text-center">
											{formatDate(item.start_date)}
											{item.end_date ? ` - ${formatDate(item.end_date)}` : ""}
										</td>
										<td className="text-center">
											{!item.is_active &&
												<span className="bg-danger bg-border"></span>
											}
											{item.is_active &&
												<span className="bg-primary bg-border"></span>
											}
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${item.id || index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<Link className="table-dropdown-item" to={`/employee-time-rates/update/${item.id}`}>
															<i className="uil-edit-alt"></i>
															{t("edit")}
														</Link>
														<Link className="table-dropdown-item" to={`/employee-time-rates/create?copy=${item.id}`}>
															<i className="uil-copy-alt"></i>
															{t("copy")}
														</Link>
														<div
															className="table-dropdown-item text-danger"
															onClick={() => {
																setDeleteId(item.id)
																setModalDelete(true)
															}}
														>
															<i className="uil-times"></i>
															{t("delete")}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
								{!data.length &&
									<tr>
										<td colSpan={8} className="text-center text-muted">{t("list_empty")}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Index
